/* Share collection comparison field definitions; listing-product.js owns data loading. */
if (!customElements.get('listing-comparison-fields')) {
  customElements.define('listing-comparison-fields', class extends HTMLElement {
    connectedCallback() {
      const rows = Array.from(this.querySelectorAll('[data-listing-compare-field]'));
      const fields = window.ieGeekProductCompareFields;
      if (!rows.length || !Array.isArray(fields) || !fields.length) return;
      const fragment = document.createDocumentFragment();
      fields.forEach(field => {
        // Existing Listing loader resolves the same aliases used by collection comparisons.
        const row = document.createElement('div');
        row.className = 'listing-compare__row';
        row.dataset.listingCompareField = field.aliases?.[0] || field.label;
        const label = document.createElement('div');
        label.className = 'listing-compare__label';
        label.textContent = field.label;
        row.appendChild(label);
        for (let column = 1; column <= 3; column++) {
          const cell = document.createElement('div');
          cell.className = 'listing-compare__cell';
          const mobileLabel = document.createElement('span');
          mobileLabel.className = 'listing-compare__cell-label';
          mobileLabel.textContent = field.label;
          const value = document.createElement('span');
          value.dataset.listingCompareCell = column;
          value.textContent = '—';
          cell.append(mobileLabel, value);
          row.appendChild(cell);
        }
        fragment.appendChild(row);
      });
      rows.forEach(row => row.remove());
      this.appendChild(fragment);
      // The collection loader may already be registered by another section.
      // Refresh existing Listing listeners if they populated the fallback rows first.
      const comparison = this.closest('.listing-compare');
      if (comparison?.dataset.initialized === 'true') {
        comparison.querySelectorAll('[data-listing-compare-select]').forEach(select => {
          select.dispatchEvent(new Event('change'));
        });
      }
    }
  });
}
